import PropTypes from 'prop-types';
export const searchTooltipPropTypes = {
  /**
   * Href content added to link href
   */
  href: PropTypes.string,
  /**
   * Position of element passed as an object which passes top and left values for component
   */
  position: PropTypes.shape({
    top: PropTypes.number,
    left: PropTypes.number
  }),
  /**
   * Label content
   */
  label: PropTypes.string,
  /**
   * onClick function
   */
  onClick: PropTypes.func,
  /**
   * Open value
   */
  open: PropTypes.bool
};